


import React from 'react'
import './Nutrition.css'




const Nutrition:React.FC = () => {

  return (
    <>
    <div className='w-screen overflow-hidden min-h-screen p-10 custom-nutrition-container'>
        <div className='flex flex-col items-center justify-center mx-auto max-w-[800px]'>

            <div className=' sm:text-lg md:text-xl lg:text-3xl xl:text-4xl  font-sans'><h3>Nutrition & Health Tips</h3></div>
            <div className=' text-center font-sans w-[70%] p-10'><p>At Next Play Nation, we believe peak performance starts with a strong foundation in nutrition and health.
                 That’s why we equip our athletes with essential tips and guidance to fuel their bodies the right way. 
                 From smart eating habits to proper hydration and recovery strategies, we’re here to support your overall well-being so you can train harder, 
                recover faster, and perform at your best—on and off the field. Because taking care of your body is just as important as developing your skills.</p></div>

        </div>
    </div>
    
    
    
    
    
    
    </>
  )
}

export default Nutrition
